export const EMOJI_MAP = {
  // FACE
  "alien-monster": "alien-monster.svg",
  alien: "alien.svg",
  "anger-symbol": "anger-symbol.svg",
  "angry-face-with-horns": "angry-face-with-horns.svg",
  "angry-face": "angry-face.svg",
  "anguished-face": "anguished-face.svg",
  "anxious-face-with-sweat": "anxious-face-with-sweat.svg",
  "astonished-face": "astonished-face.svg",
  "beaming-face-with-smiling-eyes": "beaming-face-with-smiling-eyes.svg",
  "beating-heart": "beating-heart.svg",
  "black-heart": "black-heart.svg",
  "blue-heart": "blue-heart.svg",
  bomb: "bomb.svg",
  "broken-heart": "broken-heart.svg",
  "brown-heart": "brown-heart.svg",
  "cat-with-tears-of-joy": "cat-with-tears-of-joy.svg",
  "cat-with-wry-smile": "cat-with-wry-smile.svg",
  "clown-face": "clown-face.svg",
  "cold-face": "cold-face.svg",
  collision: "collision.svg",
  "confounded-face": "confounded-face.svg",
  "confused-face": "confused-face.svg",
  "cowboy-hat-face": "cowboy-hat-face.svg",
  "crying-cat": "crying-cat.svg",
  "crying-face": "crying-face.svg",
  "dashing-away": "dashing-away.svg",
  "disappointed-face": "disappointed-face.svg",
  "disguised-face": "disguised-face.svg",
  dizzy: "dizzy.svg",
  "dotted-line-face": "dotted-line-face.svg",
  "downcast-face-with-sweat": "downcast-face-with-sweat.svg",
  "drooling-face": "drooling-face.svg",
  "exploding-head": "exploding-head.svg",
  "expressionless-face": "expressionless-face.svg",
  "eye-in-speech-bubble": "eye-in-speech-bubble.svg",
  "face-blowing-a-kiss": "face-blowing-a-kiss.svg",
  "face-exhaling": "face-exhaling.svg",
  "face-holding-back-tears": "face-holding-back-tears.svg",
  "face-in-clouds": "face-in-clouds.svg",
  "face-savoring-food": "face-savoring-food.svg",
  "face-screaming-in-fear": "face-screaming-in-fear.svg",
  "face-vomiting": "face-vomiting.svg",
  "face-with-diagonal-mouth": "face-with-diagonal-mouth.svg",
  "face-with-hand-over-mouth": "face-with-hand-over-mouth.svg",
  "face-with-head-bandage": "face-with-head-bandage.svg",
  "face-with-medical-mask": "face-with-medical-mask.svg",
  "face-with-monocle": "face-with-monocle.svg",
  "face-with-open-eyes-and-hand-over-mouth":
    "face-with-open-eyes-and-hand-over-mouth.svg",
  "face-with-open-mouth": "face-with-open-mouth.svg",
  "face-with-peeking-eye": "face-with-peeking-eye.svg",
  "face-with-raised-eyebrow": "face-with-raised-eyebrow.svg",
  "face-with-rolling-eyes": "face-with-rolling-eyes.svg",
  "face-with-spiral-eyes": "face-with-spiral-eyes.svg",
  "face-with-steam-from-nose": "face-with-steam-from-nose.svg",
  "face-with-symbols-on-mouth": "face-with-symbols-on-mouth.svg",
  "face-with-tears-of-joy": "face-with-tears-of-joy.svg",
  "face-with-thermometer": "face-with-thermometer.svg",
  "face-with-tongue": "face-with-tongue.svg",
  "face-without-mouth": "face-without-mouth.svg",
  "fearful-face": "fearful-face.svg",
  "flushed-face": "flushed-face.svg",
  "frowning-face-with-open-mouth": "frowning-face-with-open-mouth.svg",
  "frowning-face": "frowning-face.svg",
  ghost: "ghost.svg",
  goblin: "goblin.svg",
  "green-heart": "green-heart.svg",
  "grey-heart": "grey-heart.svg",
  "grimacing-face": "grimacing-face.svg",
  "grinning-cat-with-smiling-eyes": "grinning-cat-with-smiling-eyes.svg",
  "grinning-cat": "grinning-cat.svg",
  "grinning-face-with-big-eyes": "grinning-face-with-big-eyes.svg",
  "grinning-face-with-smiling-eyes": "grinning-face-with-smiling-eyes.svg",
  "grinning-face-with-sweat": "grinning-face-with-sweat.svg",
  "grinning-face": "grinning-face.svg",
  "grinning-squinting-face": "grinning-squinting-face.svg",
  "growing-heart": "growing-heart.svg",
  "hear-no-evil-monkey": "hear-no-evil-monkey.svg",
  "heart-decoration": "heart-decoration.svg",
  "heart-exclamation": "heart-exclamation.svg",
  "heart-on-fire": "heart-on-fire.svg",
  "heart-with-arrow": "heart-with-arrow.svg",
  "heart-with-ribbon": "heart-with-ribbon.svg",
  hole: "hole.svg",
  "hot-face": "hot-face.svg",
  "hugging-face": "hugging-face.svg",
  "hundred-points": "hundred-points.svg",
  "hushed-face": "hushed-face.svg",
  "kiss-mark": "kiss-mark.svg",
  "kissing-cat": "kissing-cat.svg",
  "kissing-face-with-closed-eyes": "kissing-face-with-closed-eyes.svg",
  "kissing-face-with-smiling-eyes": "kissing-face-with-smiling-eyes.svg",
  "kissing-face": "kissing-face.svg",
  "knocked-out-face": "knocked-out-face.svg",
  "left-speech-bubble": "left-speech-bubble.svg",
  "light-blue-heart": "light-blue-heart.svg",
  "loudly-crying-face": "loudly-crying-face.svg",
  "love-letter": "love-letter.svg",
  "lying-face": "lying-face.svg",
  "melting-face": "melting-face.svg",
  "mending-heart": "mending-heart.svg",
  "money-mouth-face": "money-mouth-face.svg",
  "nauseated-face": "nauseated-face.svg",
  "nerd-face": "nerd-face.svg",
  "neutral-face": "neutral-face.svg",
  ogre: "ogre.svg",
  "orange-heart": "orange-heart.svg",
  "partying-face": "partying-face.svg",
  "pensive-face": "pensive-face.svg",
  "persevering-face": "persevering-face.svg",
  "pile-of-poo": "pile-of-poo.svg",
  "pink-heart": "pink-heart.svg",
  "pleading-face": "pleading-face.svg",
  "pouting-cat": "pouting-cat.svg",
  "pouting-face": "pouting-face.svg",
  "purple-heart": "purple-heart.svg",
  "red-heart": "red-heart.svg",
  "relieved-face": "relieved-face.svg",
  "revolving-hearts": "revolving-hearts.svg",
  "right-anger-bubble": "right-anger-bubble.svg",
  robot: "robot.svg",
  "rolling-on-the-floor-laughing": "rolling-on-the-floor-laughing.svg",
  "sad-but-relieved-face": "sad-but-relieved-face.svg",
  "saluting-face": "saluting-face.svg",
  "see-no-evil-monkey": "see-no-evil-monkey.svg",
  "shaking-face": "shaking-face.svg",
  "shushing-face": "shushing-face.svg",
  "skull-and-crossbones": "skull-and-crossbones.svg",
  skull: "skull.svg",
  "sleeping-face": "sleeping-face.svg",
  "sleepy-face": "sleepy-face.svg",
  "slightly-frowning-face": "slightly-frowning-face.svg",
  "slightly-smiling-face": "slightly-smiling-face.svg",
  "smiling-cat-with-heart-eyes": "smiling-cat-with-heart-eyes.svg",
  "smiling-face-with-halo": "smiling-face-with-halo.svg",
  "smiling-face-with-heart-eyes": "smiling-face-with-heart-eyes.svg",
  "smiling-face-with-hearts": "smiling-face-with-hearts.svg",
  "smiling-face-with-horns": "smiling-face-with-horns.svg",
  "smiling-face-with-smiling-eyes": "smiling-face-with-smiling-eyes.svg",
  "smiling-face-with-sunglasses": "smiling-face-with-sunglasses.svg",
  "smiling-face-with-tear": "smiling-face-with-tear.svg",
  "smiling-face": "smiling-face.svg",
  "smirking-face": "smirking-face.svg",
  "sneezing-face": "sneezing-face.svg",
  "sparkling-heart": "sparkling-heart.svg",
  "speak-no-evil-monkey": "speak-no-evil-monkey.svg",
  "speech-balloon": "speech-balloon.svg",
  "squinting-face-with-tongue": "squinting-face-with-tongue.svg",
  "star-struck": "star-struck.svg",
  "sweat-droplets": "sweat-droplets.svg",
  "thinking-face": "thinking-face.svg",
  "thought-balloon": "thought-balloon.svg",
  "tired-face": "tired-face.svg",
  "two-hearts": "two-hearts.svg",
  "unamused-face": "unamused-face.svg",
  "upside-down-face": "upside-down-face.svg",
  "weary-cat": "weary-cat.svg",
  "weary-face": "weary-face.svg",
  "white-heart": "white-heart.svg",
  "winking-face-with-tongue": "winking-face-with-tongue.svg",
  "winking-face": "winking-face.svg",
  "woozy-face": "woozy-face.svg",
  "worried-face": "worried-face.svg",
  "yawning-face": "yawning-face.svg",
  "yellow-heart": "yellow-heart.svg",
  "zany-face": "zany-face.svg",
  "zipper-mouth-face": "zipper-mouth-face.svg",
  zzz: "zzz.svg",
  // OBJECT
  socks: "socks.svg",
  "t-shirt": "t-shirt.svg",
  ladder: "ladder.svg",
  violin: "violin.svg",
  receipt: "receipt.svg",
  pick: "pick.svg",
  flashlight: "flashlight.svg",
  abacus: "abacus.svg",
  megaphone: "megaphone.svg",
  moai: "moai.svg",
  jeans: "jeans.svg",
  "hammer-and-wrench": "hammer-and-wrench.svg",
  "locked-with-pen": "locked-with-pen.svg",
  bed: "bed.svg",
  "womans-hat": "womans-hat.svg",
  "locked-with-key": "locked-with-key.svg",
  "hair-pick": "hair-pick.svg",
  "old-key": "old-key.svg",
  clamp: "clamp.svg",
  "chart-increasing-with-yen": "chart-increasing-with-yen.svg",
  scissors: "scissors.svg",
  "funeral-urn": "funeral-urn.svg",
  "red-paper-lantern": "red-paper-lantern.svg",
  "one-piece-swimsuit": "one-piece-swimsuit.svg",
  "open-book": "open-book.svg",
  lipstick: "lipstick.svg",
  toolbox: "toolbox.svg",
  "electric-plug": "electric-plug.svg",
  "lotion-bottle": "lotion-bottle.svg",
  "womans-clothes": "womans-clothes.svg",
  "fax-machine": "fax-machine.svg",
  "nut-and-bolt": "nut-and-bolt.svg",
  scarf: "scarf.svg",
  "file-cabinet": "file-cabinet.svg",
  "studio-microphone": "studio-microphone.svg",
  "control-knobs": "control-knobs.svg",
  handbag: "handbag.svg",
  television: "television.svg",
  "open-mailbox-with-raised-flag": "open-mailbox-with-raised-flag.svg",
  crayon: "crayon.svg",
  "identification-card": "identification-card.svg",
  sponge: "sponge.svg",
  backpack: "backpack.svg",
  "diya-lamp": "diya-lamp.svg",
  "ballet-shoes": "ballet-shoes.svg",
  candle: "candle.svg",
  "rolled-up-newspaper": "rolled-up-newspaper.svg",
  "straight-ruler": "straight-ruler.svg",
  "fountain-pen": "fountain-pen.svg",
  briefcase: "briefcase.svg",
  "card-index-dividers": "card-index-dividers.svg",
  shower: "shower.svg",
  label: "label.svg",
  "musical-score": "musical-score.svg",
  "blue-book": "blue-book.svg",
  placard: "placard.svg",
  "optical-disk": "optical-disk.svg",
  microphone: "microphone.svg",
  books: "books.svg",
  "postal-horn": "postal-horn.svg",
  loudspeaker: "loudspeaker.svg",
  "folding-hand-fan": "folding-hand-fan.svg",
  toothbrush: "toothbrush.svg",
  "womans-sandal": "womans-sandal.svg",
  accordion: "accordion.svg",
  "money-with-wings": "money-with-wings.svg",
  "chart-increasing": "chart-increasing.svg",
  hook: "hook.svg",
  dagger: "dagger.svg",
  keyboard: "keyboard.svg",
  videocassette: "videocassette.svg",
  cigarette: "cigarette.svg",
  "bar-chart": "bar-chart.svg",
  "thong-sandal": "thong-sandal.svg",
  flute: "flute.svg",
  "x-ray": "x-ray.svg",
  "crossed-swords": "crossed-swords.svg",
  pen: "pen.svg",
  clipboard: "clipboard.svg",
  package: "package.svg",
  link: "link.svg",
  "camera-with-flash": "camera-with-flash.svg",
  key: "key.svg",
  "incoming-envelope": "incoming-envelope.svg",
  bathtub: "bathtub.svg",
  "closed-mailbox-with-lowered-flag": "closed-mailbox-with-lowered-flag.svg",
  telescope: "telescope.svg",
  "triangular-ruler": "triangular-ruler.svg",
  "bow-and-arrow": "bow-and-arrow.svg",
  "muted-speaker": "muted-speaker.svg",
  "card-file-box": "card-file-box.svg",
  envelope: "envelope.svg",
  "running-shoe": "running-shoe.svg",
  "mans-shoe": "mans-shoe.svg",
  "shopping-bags": "shopping-bags.svg",
  magnet: "magnet.svg",
  shield: "shield.svg",
  "musical-note": "musical-note.svg",
  "carpentry-saw": "carpentry-saw.svg",
  briefs: "briefs.svg",
  "speaker-medium-volume": "speaker-medium-volume.svg",
  "billed-cap": "billed-cap.svg",
  "military-helmet": "military-helmet.svg",
  "inbox-tray": "inbox-tray.svg",
  dna: "dna.svg",
  radio: "radio.svg",
  "clapper-board": "clapper-board.svg",
  "black-nib": "black-nib.svg",
  "dollar-banknote": "dollar-banknote.svg",
  wastebasket: "wastebasket.svg",
  "adhesive-bandage": "adhesive-bandage.svg",
  bell: "bell.svg",
  maracas: "maracas.svg",
  trackball: "trackball.svg",
  battery: "battery.svg",
  newspaper: "newspaper.svg",
  bikini: "bikini.svg",
  "mouse-trap": "mouse-trap.svg",
  "flat-shoe": "flat-shoe.svg",
  dvd: "dvd.svg",
  "drop-of-blood": "drop-of-blood.svg",
  plunger: "plunger.svg",
  "gem-stone": "gem-stone.svg",
  "speaker-low-volume": "speaker-low-volume.svg",
  boomerang: "boomerang.svg",
  "top-hat": "top-hat.svg",
  "open-file-folder": "open-file-folder.svg",
  gear: "gear.svg",
  "rescue-workers-helmet": "rescue-workers-helmet.svg",
  ledger: "ledger.svg",
  "petri-dish": "petri-dish.svg",
  "magnifying-glass-tilted-right": "magnifying-glass-tilted-right.svg",
  "pound-banknote": "pound-banknote.svg",
  "telephone-receiver": "telephone-receiver.svg",
  glasses: "glasses.svg",
  "low-battery": "low-battery.svg",
  "prayer-beads": "prayer-beads.svg",
  "fire-extinguisher": "fire-extinguisher.svg",
  razor: "razor.svg",
  pager: "pager.svg",
  "roll-of-paper": "roll-of-paper.svg",
  "outbox-tray": "outbox-tray.svg",
  "yen-banknote": "yen-banknote.svg",
  paperclip: "paperclip.svg",
  "computer-mouse": "computer-mouse.svg",
  "chart-decreasing": "chart-decreasing.svg",
  "couch-and-lamp": "couch-and-lamp.svg",
  syringe: "syringe.svg",
  gloves: "gloves.svg",
  necktie: "necktie.svg",
  saxophone: "saxophone.svg",
  crown: "crown.svg",
  broom: "broom.svg",
  stethoscope: "stethoscope.svg",
  kimono: "kimono.svg",
  purse: "purse.svg",
  coin: "coin.svg",
  unlocked: "unlocked.svg",
  "tear-off-calendar": "tear-off-calendar.svg",
  "mobile-phone-with-arrow": "mobile-phone-with-arrow.svg",
  trumpet: "trumpet.svg",
  "magnifying-glass-tilted-left": "magnifying-glass-tilted-left.svg",
  scroll: "scroll.svg",
  "satellite-antenna": "satellite-antenna.svg",
  "page-with-curl": "page-with-curl.svg",
  camera: "camera.svg",
  printer: "printer.svg",
  "floppy-disk": "floppy-disk.svg",
  dress: "dress.svg",
  bucket: "bucket.svg",
  "film-projector": "film-projector.svg",
  "lab-coat": "lab-coat.svg",
  bubbles: "bubbles.svg",
  toilet: "toilet.svg",
  coffin: "coffin.svg",
  postbox: "postbox.svg",
  goggles: "goggles.svg",
  telephone: "telephone.svg",
  "graduation-cap": "graduation-cap.svg",
  guitar: "guitar.svg",
  "round-pushpin": "round-pushpin.svg",
  wrench: "wrench.svg",
  "bell-with-slash": "bell-with-slash.svg",
  soap: "soap.svg",
  crutch: "crutch.svg",
  hammer: "hammer.svg",
  banjo: "banjo.svg",
  "water-pistol": "water-pistol.svg",
  sunglasses: "sunglasses.svg",
  "card-index": "card-index.svg",
  "bookmark-tabs": "bookmark-tabs.svg",
  "credit-card": "credit-card.svg",
  "ballot-box-with-ballot": "ballot-box-with-ballot.svg",
  "speaker-high-volume": "speaker-high-volume.svg",
  "euro-banknote": "euro-banknote.svg",
  pencil: "pencil.svg",
  "spiral-notepad": "spiral-notepad.svg",
  "mobile-phone": "mobile-phone.svg",
  "movie-camera": "movie-camera.svg",
  "linked-paperclips": "linked-paperclips.svg",
  "level-slider": "level-slider.svg",
  "closed-mailbox-with-raised-flag": "closed-mailbox-with-raised-flag.svg",
  headphone: "headphone.svg",
  "light-bulb": "light-bulb.svg",
  "green-book": "green-book.svg",
  pill: "pill.svg",
  axe: "axe.svg",
  "notebook-with-decorative-cover": "notebook-with-decorative-cover.svg",
  "orange-book": "orange-book.svg",
  "balance-scale": "balance-scale.svg",
  microscope: "microscope.svg",
  "test-tube": "test-tube.svg",
  drum: "drum.svg",
  "spiral-calendar": "spiral-calendar.svg",
  "closed-book": "closed-book.svg",
  "hammer-and-pick": "hammer-and-pick.svg",
  door: "door.svg",
  alembic: "alembic.svg",
  calendar: "calendar.svg",
  "video-camera": "video-camera.svg",
  "musical-notes": "musical-notes.svg",
  paintbrush: "paintbrush.svg",
  "white-cane": "white-cane.svg",
  "safety-pin": "safety-pin.svg",
  laptop: "laptop.svg",
  "desktop-computer": "desktop-computer.svg",
  "page-facing-up": "page-facing-up.svg",
  "open-mailbox-with-lowered-flag": "open-mailbox-with-lowered-flag.svg",
  "high-heeled-shoe": "high-heeled-shoe.svg",
  shorts: "shorts.svg",
  window: "window.svg",
  chair: "chair.svg",
  memo: "memo.svg",
  sari: "sari.svg",
  bookmark: "bookmark.svg",
  coat: "coat.svg",
  "long-drum": "long-drum.svg",
  elevator: "elevator.svg",
  "envelope-with-arrow": "envelope-with-arrow.svg",
  "computer-disk": "computer-disk.svg",
  pushpin: "pushpin.svg",
  ring: "ring.svg",
  "shopping-cart": "shopping-cart.svg",
  "safety-vest": "safety-vest.svg",
  "money-bag": "money-bag.svg",
  "hiking-boot": "hiking-boot.svg",
  locked: "locked.svg",
  "film-frames": "film-frames.svg",
  screwdriver: "screwdriver.svg",
  mirror: "mirror.svg",
  "clutch-bag": "clutch-bag.svg",
  "file-folder": "file-folder.svg",
  "musical-keyboard": "musical-keyboard.svg",
  "e-mail": "e-mail.svg",
  basket: "basket.svg",
  "womans-boot": "womans-boot.svg",
  notebook: "notebook.svg",
  chains: "chains.svg",
  headstone: "headstone.svg",
  // FOOD & DRINK
  oden: "oden.svg",
  croissant: "croissant.svg",
  "moon-cake": "moon-cake.svg",
  "clinking-glasses": "clinking-glasses.svg",
  tomato: "tomato.svg",
  sake: "sake.svg",
  blueberries: "blueberries.svg",
  burrito: "burrito.svg",
  hamburger: "hamburger.svg",
  "pot-of-food": "pot-of-food.svg",
  mate: "mate.svg",
  falafel: "falafel.svg",
  "hot-dog": "hot-dog.svg",
  butter: "butter.svg",
  "fried-shrimp": "fried-shrimp.svg",
  tangerine: "tangerine.svg",
  onion: "onion.svg",
  mango: "mango.svg",
  "hot-beverage": "hot-beverage.svg",
  "baby-bottle": "baby-bottle.svg",
  "chocolate-bar": "chocolate-bar.svg",
  lobster: "lobster.svg",
  "bell-pepper": "bell-pepper.svg",
  "takeout-box": "takeout-box.svg",
  cooking: "cooking.svg",
  shrimp: "shrimp.svg",
  cookie: "cookie.svg",
  beans: "beans.svg",
  pineapple: "pineapple.svg",
  squid: "squid.svg",
  "tropical-drink": "tropical-drink.svg",
  carrot: "carrot.svg",
  dango: "dango.svg",
  "fish-cake-with-swirl": "fish-cake-with-swirl.svg",
  coconut: "coconut.svg",
  "pouring-liquid": "pouring-liquid.svg",
  "steaming-bowl": "steaming-bowl.svg",
  salt: "salt.svg",
  oyster: "oyster.svg",
  amphora: "amphora.svg",
  "cocktail-glass": "cocktail-glass.svg",
  "green-salad": "green-salad.svg",
  "clinking-beer-mugs": "clinking-beer-mugs.svg",
  potato: "potato.svg",
  "kitchen-knife": "kitchen-knife.svg",
  "birthday-cake": "birthday-cake.svg",
  "beer-mug": "beer-mug.svg",
  "kiwi-fruit": "kiwi-fruit.svg",
  "fork-and-knife-with-plate": "fork-and-knife-with-plate.svg",
  bread: "bread.svg",
  shortcake: "shortcake.svg",
  candy: "candy.svg",
  "ear-of-corn": "ear-of-corn.svg",
  jar: "jar.svg",
  pancakes: "pancakes.svg",
  chestnut: "chestnut.svg",
  spaghetti: "spaghetti.svg",
  peach: "peach.svg",
  pretzel: "pretzel.svg",
  "cheese-wedge": "cheese-wedge.svg",
  fondue: "fondue.svg",
  "green-apple": "green-apple.svg",
  waffle: "waffle.svg",
  "meat-on-bone": "meat-on-bone.svg",
  "cooked-rice": "cooked-rice.svg",
  custard: "custard.svg",
  tamale: "tamale.svg",
  mushroom: "mushroom.svg",
  "canned-food": "canned-food.svg",
  "bento-box": "bento-box.svg",
  popcorn: "popcorn.svg",
  spoon: "spoon.svg",
  "rice-cracker": "rice-cracker.svg",
  "stuffed-flatbread": "stuffed-flatbread.svg",
  dumpling: "dumpling.svg",
  broccoli: "broccoli.svg",
  pie: "pie.svg",
  "glass-of-milk": "glass-of-milk.svg",
  chopsticks: "chopsticks.svg",
  taco: "taco.svg",
  cupcake: "cupcake.svg",
  "bowl-with-spoon": "bowl-with-spoon.svg",
  "leafy-green": "leafy-green.svg",
  "cup-with-straw": "cup-with-straw.svg",
  "wine-glass": "wine-glass.svg",
  "hot-pepper": "hot-pepper.svg",
  "red-apple": "red-apple.svg",
  egg: "egg.svg",
  "fortune-cookie": "fortune-cookie.svg",
  "beverage-box": "beverage-box.svg",
  "poultry-leg": "poultry-leg.svg",
  strawberry: "strawberry.svg",
  eggplant: "eggplant.svg",
  sandwich: "sandwich.svg",
  "rice-ball": "rice-ball.svg",
  "teacup-without-handle": "teacup-without-handle.svg",
  pizza: "pizza.svg",
  bacon: "bacon.svg",
  teapot: "teapot.svg",
  "honey-pot": "honey-pot.svg",
  "pea-pod": "pea-pod.svg",
  banana: "banana.svg",
  lemon: "lemon.svg",
  cucumber: "cucumber.svg",
  sushi: "sushi.svg",
  "french-fries": "french-fries.svg",
  crab: "crab.svg",
  "cut-of-meat": "cut-of-meat.svg",
  "soft-ice-cream": "soft-ice-cream.svg",
  "bottle-with-popping-cork": "bottle-with-popping-cork.svg",
  "baguette-bread": "baguette-bread.svg",
  flatbread: "flatbread.svg",
  "shaved-ice": "shaved-ice.svg",
  "ginger-root": "ginger-root.svg",
  melon: "melon.svg",
  "shallow-pan-of-food": "shallow-pan-of-food.svg",
  bagel: "bagel.svg",
  pear: "pear.svg",
  ice: "ice.svg",
  "bubble-tea": "bubble-tea.svg",
  doughnut: "doughnut.svg",
  avocado: "avocado.svg",
  "curry-rice": "curry-rice.svg",
  garlic: "garlic.svg",
  "tumbler-glass": "tumbler-glass.svg",
  olive: "olive.svg",
  "ice-cream": "ice-cream.svg",
  peanuts: "peanuts.svg",
  grapes: "grapes.svg",
  lollipop: "lollipop.svg",
  cherries: "cherries.svg",
  watermelon: "watermelon.svg",
  "roasted-sweet-potato": "roasted-sweet-potato.svg",
  "fork-and-knife": "fork-and-knife.svg",
  // ACTIVITIES
  tennis: "tennis.svg",
  knot: "knot.svg",
  "cricket-game": "cricket-game.svg",
  "pine-decoration": "pine-decoration.svg",
  "wrapped-gift": "wrapped-gift.svg",
  "party-popper": "party-popper.svg",
  skis: "skis.svg",
  "yo-yo": "yo-yo.svg",
  badminton: "badminton.svg",
  ticket: "ticket.svg",
  lacrosse: "lacrosse.svg",
  "game-die": "game-die.svg",
  sparkler: "sparkler.svg",
  "flying-disc": "flying-disc.svg",
  "red-envelope": "red-envelope.svg",
  "3rd-place-medal": "3rd-place-medal.svg",
  "heart-suit": "heart-suit.svg",
  sparkles: "sparkles.svg",
  joystick: "joystick.svg",
  "christmas-tree": "christmas-tree.svg",
  "slot-machine": "slot-machine.svg",
  "flower-playing-cards": "flower-playing-cards.svg",
  hamsa: "hamsa.svg",
  "admission-tickets": "admission-tickets.svg",
  "curling-stone": "curling-stone.svg",
  "magic-wand": "magic-wand.svg",
  "diamond-suit": "diamond-suit.svg",
  "fishing-pole": "fishing-pole.svg",
  "japanese-dolls": "japanese-dolls.svg",
  "ping-pong": "ping-pong.svg",
  "tanabata-tree": "tanabata-tree.svg",
  fireworks: "fireworks.svg",
  trophy: "trophy.svg",
  bowling: "bowling.svg",
  sled: "sled.svg",
  "goal-net": "goal-net.svg",
  "ice-skate": "ice-skate.svg",
  "video-game": "video-game.svg",
  volleyball: "volleyball.svg",
  "carp-streamer": "carp-streamer.svg",
  "american-football": "american-football.svg",
  "artist-palette": "artist-palette.svg",
  "rugby-football": "rugby-football.svg",
  kite: "kite.svg",
  "crystal-ball": "crystal-ball.svg",
  firecracker: "firecracker.svg",
  yarn: "yarn.svg",
  "nazar-amulet": "nazar-amulet.svg",
  "confetti-ball": "confetti-ball.svg",
  "soccer-ball": "soccer-ball.svg",
  "jack-o-lantern": "jack-o-lantern.svg",
  "nesting-dolls": "nesting-dolls.svg",
  softball: "softball.svg",
  bullseye: "bullseye.svg",
  "running-shirt": "running-shirt.svg",
  "diving-mask": "diving-mask.svg",
  piñata: "piñata.svg",
  "pool-8-ball": "pool-8-ball.svg",
  "mahjong-red-dragon": "mahjong-red-dragon.svg",
  thread: "thread.svg",
  "framed-picture": "framed-picture.svg",
  "martial-arts-uniform": "martial-arts-uniform.svg",
  "teddy-bear": "teddy-bear.svg",
  "spade-suit": "spade-suit.svg",
  "boxing-glove": "boxing-glove.svg",
  basketball: "basketball.svg",
  "sewing-needle": "sewing-needle.svg",
  "1st-place-medal": "1st-place-medal.svg",
  baseball: "baseball.svg",
  "puzzle-piece": "puzzle-piece.svg",
  "chess-pawn": "chess-pawn.svg",
  "sports-medal": "sports-medal.svg",
  "reminder-ribbon": "reminder-ribbon.svg",
  "2nd-place-medal": "2nd-place-medal.svg",
  "club-suit": "club-suit.svg",
  balloon: "balloon.svg",
  "field-hockey": "field-hockey.svg",
  "flag-in-hole": "flag-in-hole.svg",
  "ice-hockey": "ice-hockey.svg",
  "performing-arts": "performing-arts.svg",
  "mirror-ball": "mirror-ball.svg",
  "wind-chime": "wind-chime.svg",
  "moon-viewing-ceremony": "moon-viewing-ceremony.svg",
  ribbon: "ribbon.svg",
  joker: "joker.svg",
  "military-medal": "military-medal.svg",
  // TRAVEL & PLACE
  "railway-car": "railway-car.svg",
  "roller-skate": "roller-skate.svg",
  "high-speed-train": "high-speed-train.svg",
  "crescent-moon": "crescent-moon.svg",
  house: "house.svg",
  "small-airplane": "small-airplane.svg",
  stadium: "stadium.svg",
  "five-thirty": "five-thirty.svg",
  "barber-pole": "barber-pole.svg",
  "waxing-gibbous-moon": "waxing-gibbous-moon.svg",
  luggage: "luggage.svg",
  "airplane-departure": "airplane-departure.svg",
  "manual-wheelchair": "manual-wheelchair.svg",
  "sunrise-over-mountains": "sunrise-over-mountains.svg",
  wood: "wood.svg",
  "playground-slide": "playground-slide.svg",
  fountain: "fountain.svg",
  "umbrella-with-rain-drops": "umbrella-with-rain-drops.svg",
  volcano: "volcano.svg",
  metro: "metro.svg",
  sunrise: "sunrise.svg",
  rock: "rock.svg",
  "high-voltage": "high-voltage.svg",
  umbrella: "umbrella.svg",
  "pickup-truck": "pickup-truck.svg",
  automobile: "automobile.svg",
  "three-thirty": "three-thirty.svg",
  "love-hotel": "love-hotel.svg",
  "sun-with-face": "sun-with-face.svg",
  "house-with-garden": "house-with-garden.svg",
  "full-moon-face": "full-moon-face.svg",
  "motorized-wheelchair": "motorized-wheelchair.svg",
  camping: "camping.svg",
  church: "church.svg",
  "waning-gibbous-moon": "waning-gibbous-moon.svg",
  "bridge-at-night": "bridge-at-night.svg",
  cityscape: "cityscape.svg",
  "twelve-thirty": "twelve-thirty.svg",
  "waxing-crescent-moon": "waxing-crescent-moon.svg",
  "cloud-with-lightning-and-rain": "cloud-with-lightning-and-rain.svg",
  "last-quarter-moon-face": "last-quarter-moon-face.svg",
  "sun-behind-large-cloud": "sun-behind-large-cloud.svg",
  trolleybus: "trolleybus.svg",
  tornado: "tornado.svg",
  "water-wave": "water-wave.svg",
  helicopter: "helicopter.svg",
  "auto-rickshaw": "auto-rickshaw.svg",
  "one-oclock": "one-oclock.svg",
  "cloud-with-rain": "cloud-with-rain.svg",
  locomotive: "locomotive.svg",
  wheel: "wheel.svg",
  "aerial-tramway": "aerial-tramway.svg",
  "bellhop-bell": "bellhop-bell.svg",
  monorail: "monorail.svg",
  droplet: "droplet.svg",
  parachute: "parachute.svg",
  "ten-thirty": "ten-thirty.svg",
  "eight-oclock": "eight-oclock.svg",
  "convenience-store": "convenience-store.svg",
  "globe-showing-americas": "globe-showing-americas.svg",
  "world-map": "world-map.svg",
  "timer-clock": "timer-clock.svg",
  fire: "fire.svg",
  "milky-way": "milky-way.svg",
  "new-moon-face": "new-moon-face.svg",
  "hourglass-done": "hourglass-done.svg",
  "six-thirty": "six-thirty.svg",
  ferry: "ferry.svg",
  sailboat: "sailboat.svg",
  "mantelpiece-clock": "mantelpiece-clock.svg",
  "oil-drum": "oil-drum.svg",
  ship: "ship.svg",
  "eleven-thirty": "eleven-thirty.svg",
  "nine-thirty": "nine-thirty.svg",
  ambulance: "ambulance.svg",
  stopwatch: "stopwatch.svg",
  hut: "hut.svg",
  seat: "seat.svg",
  "sun-behind-small-cloud": "sun-behind-small-cloud.svg",
  "light-rail": "light-rail.svg",
  "police-car-light": "police-car-light.svg",
  "ring-buoy": "ring-buoy.svg",
  houses: "houses.svg",
  "sport-utility-vehicle": "sport-utility-vehicle.svg",
  "bullet-train": "bullet-train.svg",
  school: "school.svg",
  "desert-island": "desert-island.svg",
  "national-park": "national-park.svg",
  castle: "castle.svg",
  "oncoming-police-car": "oncoming-police-car.svg",
  "snowman-without-snow": "snowman-without-snow.svg",
  fog: "fog.svg",
  mosque: "mosque.svg",
  satellite: "satellite.svg",
  "snow-capped-mountain": "snow-capped-mountain.svg",
  "alarm-clock": "alarm-clock.svg",
  taxi: "taxi.svg",
  hotel: "hotel.svg",
  "first-quarter-moon": "first-quarter-moon.svg",
  train: "train.svg",
  "bus-stop": "bus-stop.svg",
  "railway-track": "railway-track.svg",
  "hourglass-not-done": "hourglass-not-done.svg",
  thermometer: "thermometer.svg",
  "four-oclock": "four-oclock.svg",
  "suspension-railway": "suspension-railway.svg",
  "flying-saucer": "flying-saucer.svg",
  snowflake: "snowflake.svg",
  "circus-tent": "circus-tent.svg",
  factory: "factory.svg",
  "two-thirty": "two-thirty.svg",
  "seven-thirty": "seven-thirty.svg",
  "last-quarter-moon": "last-quarter-moon.svg",
  tent: "tent.svg",
  kaaba: "kaaba.svg",
  hospital: "hospital.svg",
  "mountain-railway": "mountain-railway.svg",
  "carousel-horse": "carousel-horse.svg",
  watch: "watch.svg",
  "roller-coaster": "roller-coaster.svg",
  "new-moon": "new-moon.svg",
  desert: "desert.svg",
  "first-quarter-moon-face": "first-quarter-moon-face.svg",
  brick: "brick.svg",
  "closed-umbrella": "closed-umbrella.svg",
  "one-thirty": "one-thirty.svg",
  rainbow: "rainbow.svg",
  "cloud-with-lightning": "cloud-with-lightning.svg",
  tram: "tram.svg",
  speedboat: "speedboat.svg",
  "globe-showing-asia-australia": "globe-showing-asia-australia.svg",
  "twelve-oclock": "twelve-oclock.svg",
  sunset: "sunset.svg",
  "shooting-star": "shooting-star.svg",
  "sun-behind-cloud": "sun-behind-cloud.svg",
  motorway: "motorway.svg",
  "globe-with-meridians": "globe-with-meridians.svg",
  station: "station.svg",
  "three-oclock": "three-oclock.svg",
  "racing-car": "racing-car.svg",
  "passenger-ship": "passenger-ship.svg",
  "kick-scooter": "kick-scooter.svg",
  cyclone: "cyclone.svg",
  "japanese-castle": "japanese-castle.svg",
  "tokyo-tower": "tokyo-tower.svg",
  bus: "bus.svg",
  "airplane-arrival": "airplane-arrival.svg",
  "cloud-with-snow": "cloud-with-snow.svg",
  wedding: "wedding.svg",
  "shinto-shrine": "shinto-shrine.svg",
  "mountain-cableway": "mountain-cableway.svg",
  "building-construction": "building-construction.svg",
  "oncoming-automobile": "oncoming-automobile.svg",
  construction: "construction.svg",
  star: "star.svg",
  "full-moon": "full-moon.svg",
  sun: "sun.svg",
  "hot-springs": "hot-springs.svg",
  "waning-crescent-moon": "waning-crescent-moon.svg",
  anchor: "anchor.svg",
  "five-oclock": "five-oclock.svg",
  skateboard: "skateboard.svg",
  "cityscape-at-dusk": "cityscape-at-dusk.svg",
  "tram-car": "tram-car.svg",
  compass: "compass.svg",
  bicycle: "bicycle.svg",
  bank: "bank.svg",
  "statue-of-liberty": "statue-of-liberty.svg",
  snowman: "snowman.svg",
  "fuel-pump": "fuel-pump.svg",
  "post-office": "post-office.svg",
  "office-building": "office-building.svg",
  "articulated-lorry": "articulated-lorry.svg",
  "vertical-traffic-light": "vertical-traffic-light.svg",
  "ringed-planet": "ringed-planet.svg",
  "wind-face": "wind-face.svg",
  "derelict-house": "derelict-house.svg",
  "horizontal-traffic-light": "horizontal-traffic-light.svg",
  "japanese-post-office": "japanese-post-office.svg",
  tractor: "tractor.svg",
  "two-oclock": "two-oclock.svg",
  "seven-oclock": "seven-oclock.svg",
  "night-with-stars": "night-with-stars.svg",
  "map-of-japan": "map-of-japan.svg",
  "motor-boat": "motor-boat.svg",
  "oncoming-taxi": "oncoming-taxi.svg",
  "classical-building": "classical-building.svg",
  "umbrella-on-ground": "umbrella-on-ground.svg",
  "fire-engine": "fire-engine.svg",
  "four-thirty": "four-thirty.svg",
  "police-car": "police-car.svg",
  "stop-sign": "stop-sign.svg",
  "sun-behind-rain-cloud": "sun-behind-rain-cloud.svg",
  "delivery-truck": "delivery-truck.svg",
  mountain: "mountain.svg",
  minibus: "minibus.svg",
  "mount-fuji": "mount-fuji.svg",
  cloud: "cloud.svg",
  motorcycle: "motorcycle.svg",
  "motor-scooter": "motor-scooter.svg",
  "globe-showing-europe-africa": "globe-showing-europe-africa.svg",
  rocket: "rocket.svg",
  "department-store": "department-store.svg",
  "eleven-oclock": "eleven-oclock.svg",
  "nine-oclock": "nine-oclock.svg",
  comet: "comet.svg",
  "glowing-star": "glowing-star.svg",
  airplane: "airplane.svg",
  "six-oclock": "six-oclock.svg",
  "oncoming-bus": "oncoming-bus.svg",
  synagogue: "synagogue.svg",
  canoe: "canoe.svg",
  "hindu-temple": "hindu-temple.svg",
  "eight-thirty": "eight-thirty.svg",
  "ten-oclock": "ten-oclock.svg",
  "beach-with-umbrella": "beach-with-umbrella.svg",
  "ferris-wheel": "ferris-wheel.svg",
  foggy: "foggy.svg",
  // ANIMALS
  orangutan: "orangutan.svg",
  "potted-plant": "potted-plant.svg",
  peacock: "peacock.svg",
  owl: "owl.svg",
  shamrock: "shamrock.svg",
  ant: "ant.svg",
  ewe: "ewe.svg",
  "pig-nose": "pig-nose.svg",
  blowfish: "blowfish.svg",
  raccoon: "raccoon.svg",
  butterfly: "butterfly.svg",
  "service-dog": "service-dog.svg",
  wing: "wing.svg",
  donkey: "donkey.svg",
  panda: "panda.svg",
  gorilla: "gorilla.svg",
  shark: "shark.svg",
  cow: "cow.svg",
  bird: "bird.svg",
  mammoth: "mammoth.svg",
  cactus: "cactus.svg",
  mosquito: "mosquito.svg",
  "mouse-face": "mouse-face.svg",
  "hatching-chick": "hatching-chick.svg",
  kangaroo: "kangaroo.svg",
  tiger: "tiger.svg",
  chicken: "chicken.svg",
  dragon: "dragon.svg",
  vector: "vector.svg",
  "pig-face": "pig-face.svg",
  hyacinth: "hyacinth.svg",
  "maple-leaf": "maple-leaf.svg",
  zebra: "zebra.svg",
  rat: "rat.svg",
  "spider-web": "spider-web.svg",
  turkey: "turkey.svg",
  "t-rex": "t-rex.svg",
  swan: "swan.svg",
  eagle: "eagle.svg",
  flamingo: "flamingo.svg",
  cricket: "cricket.svg",
  camel: "camel.svg",
  "wilted-flower": "wilted-flower.svg",
  "two-hump-camel": "two-hump-camel.svg",
  "baby-chick": "baby-chick.svg",
  "fallen-leaf": "fallen-leaf.svg",
  lion: "lion.svg",
  dolphin: "dolphin.svg",
  elephant: "elephant.svg",
  deer: "deer.svg",
  "dragon-face": "dragon-face.svg",
  "black-cat": "black-cat.svg",
  worm: "worm.svg",
  fly: "fly.svg",
  "cherry-blossom": "cherry-blossom.svg",
  boar: "boar.svg",
  bison: "bison.svg",
  rose: "rose.svg",
  ox: "ox.svg",
  "four-leaf-clover": "four-leaf-clover.svg",
  blossom: "blossom.svg",
  spider: "spider.svg",
  honeybee: "honeybee.svg",
  beaver: "beaver.svg",
  rhinoceros: "rhinoceros.svg",
  leopard: "leopard.svg",
  turtle: "turtle.svg",
  hibiscus: "hibiscus.svg",
  "tropical-fish": "tropical-fish.svg",
  unicorn: "unicorn.svg",
  sunflower: "sunflower.svg",
  seedling: "seedling.svg",
  rabbit: "rabbit.svg",
  rosette: "rosette.svg",
  whale: "whale.svg",
  poodle: "poodle.svg",
  dodo: "dodo.svg",
  "sheaf-of-rice": "sheaf-of-rice.svg",
  "spouting-whale": "spouting-whale.svg",
  horse: "horse.svg",
  "dog-face": "dog-face.svg",
  duck: "duck.svg",
  parrot: "parrot.svg",
  dog: "dog.svg",
  "empty-nest": "empty-nest.svg",
  crocodile: "crocodile.svg",
  hedgehog: "hedgehog.svg",
  skunk: "skunk.svg",
  fish: "fish.svg",
  "guide-dog": "guide-dog.svg",
  scorpion: "scorpion.svg",
  goat: "goat.svg",
  snail: "snail.svg",
  bear: "bear.svg",
  snake: "snake.svg",
  badger: "badger.svg",
  "cat-face": "cat-face.svg",
  llama: "llama.svg",
  koala: "koala.svg",
  pig: "pig.svg",
  "leaf-fluttering-in-wind": "leaf-fluttering-in-wind.svg",
  otter: "otter.svg",
  "white-flower": "white-flower.svg",
  moose: "moose.svg",
  "lady-beetle": "lady-beetle.svg",
  herb: "herb.svg",
  feather: "feather.svg",
  "rabbit-face": "rabbit-face.svg",
  beetle: "beetle.svg",
  coral: "coral.svg",
  "front-facing-baby-chick": "front-facing-baby-chick.svg",
  cockroach: "cockroach.svg",
  fox: "fox.svg",
  "black-bird": "black-bird.svg",
  "horse-face": "horse-face.svg",
  "evergreen-tree": "evergreen-tree.svg",
  giraffe: "giraffe.svg",
  seal: "seal.svg",
  bug: "bug.svg",
  "tiger-face": "tiger-face.svg",
  bat: "bat.svg",
  "nest-with-eggs": "nest-with-eggs.svg",
  monkey: "monkey.svg",
  "paw-prints": "paw-prints.svg",
  microbe: "microbe.svg",
  jellyfish: "jellyfish.svg",
  "polar-bear": "polar-bear.svg",
  chipmunk: "chipmunk.svg",
  rooster: "rooster.svg",
  lotus: "lotus.svg",
  dove: "dove.svg",
  tulip: "tulip.svg",
  lizard: "lizard.svg",
  hippopotamus: "hippopotamus.svg",
  bouquet: "bouquet.svg",
  "spiral-shell": "spiral-shell.svg",
  frog: "frog.svg",
  ram: "ram.svg",
  "deciduous-tree": "deciduous-tree.svg",
  sauropod: "sauropod.svg",
  goose: "goose.svg",
  cat: "cat.svg",
  sloth: "sloth.svg",
  mouse: "mouse.svg",
  penguin: "penguin.svg",
  hamster: "hamster.svg",
  "monkey-face": "monkey-face.svg",
  "cow-face": "cow-face.svg",
  "water-buffalo": "water-buffalo.svg",
  wolf: "wolf.svg",
  "palm-tree": "palm-tree.svg",
  // BODY
  "thumbs-down-default": "thumbs-down-default.svg",
  "hand-with-fingers-splayed-3d": "hand-with-fingers-splayed-3d.svg",
  "writing-hand-medium-light": "writing-hand-medium-light.svg",
  "heart-hands-3d": "heart-hands-3d.svg",
  "foot-medium": "foot-medium.svg",
  "writing-hand-default": "writing-hand-default.svg",
  "selfie-medium-dark": "selfie-medium-dark.svg",
  "waving-hand-medium-dark": "waving-hand-medium-dark.svg",
  "oncoming-fist-3d": "oncoming-fist-3d.svg",
  "backhand-index-pointing-right-default":
    "backhand-index-pointing-right-default.svg",
  "victory-hand-medium": "victory-hand-medium.svg",
  "backhand-index-pointing-right-medium-light":
    "backhand-index-pointing-right-medium-light.svg",
  "palm-up-hand-medium": "palm-up-hand-medium.svg",
  "rightwards-hand-medium-light": "rightwards-hand-medium-light.svg",
  "foot-dark": "foot-dark.svg",
  "palms-up-together-3d": "palms-up-together-3d.svg",
  "middle-finger-default": "middle-finger-default.svg",
  "love-you-gesture-light": "love-you-gesture-light.svg",
  "waving-hand-dark": "waving-hand-dark.svg",
  "right-facing-fist-dark": "right-facing-fist-dark.svg",
  "hand-with-index-finger-and-thumb-crossed-dark":
    "hand-with-index-finger-and-thumb-crossed-dark.svg",
  "waving-hand-light": "waving-hand-light.svg",
  "palm-up-hand-default": "palm-up-hand-default.svg",
  "thumbs-up-light": "thumbs-up-light.svg",
  "crossed-fingers-medium": "crossed-fingers-medium.svg",
  "leftwards-pushing-hand-3d": "leftwards-pushing-hand-3d.svg",
  "middle-finger-medium": "middle-finger-medium.svg",
  "rightwards-pushing-hand-default": "rightwards-pushing-hand-default.svg",
  "clapping-hands-dark": "clapping-hands-dark.svg",
  "ear-3d": "ear-3d.svg",
  "heart-hands-medium-dark": "heart-hands-medium-dark.svg",
  "crossed-fingers-default": "crossed-fingers-default.svg",
  "thumbs-down-light": "thumbs-down-light.svg",
  "raised-hand-medium-dark": "raised-hand-medium-dark.svg",
  "biting-lip": "biting-lip.svg",
  "crossed-fingers-medium-light": "crossed-fingers-medium-light.svg",
  "middle-finger-light": "middle-finger-light.svg",
  "leg-medium-light": "leg-medium-light.svg",
  "vulcan-salute-3d": "vulcan-salute-3d.svg",
  "foot-light": "foot-light.svg",
  "raised-hand-medium-light": "raised-hand-medium-light.svg",
  "sign-of-the-horns-medium-dark": "sign-of-the-horns-medium-dark.svg",
  "left-facing-fist-default": "left-facing-fist-default.svg",
  "ear-medium": "ear-medium.svg",
  "vulcan-salute-dark": "vulcan-salute-dark.svg",
  "flexed-biceps-light": "flexed-biceps-light.svg",
  "backhand-index-pointing-right-medium-dark":
    "backhand-index-pointing-right-medium-dark.svg",
  "selfie-default": "selfie-default.svg",
  "backhand-index-pointing-right-3d": "backhand-index-pointing-right-3d.svg",
  "index-pointing-up-medium": "index-pointing-up-medium.svg",
  "palms-up-together-medium-light": "palms-up-together-medium-light.svg",
  "rightwards-pushing-hand-medium": "rightwards-pushing-hand-medium.svg",
  "ear-with-hearing-aid-medium-light": "ear-with-hearing-aid-medium-light.svg",
  "open-hands-medium-dark": "open-hands-medium-dark.svg",
  "leftwards-pushing-hand-medium-dark":
    "leftwards-pushing-hand-medium-dark.svg",
  "palm-down-hand-light": "palm-down-hand-light.svg",
  "backhand-index-pointing-left-default":
    "backhand-index-pointing-left-default.svg",
  "left-facing-fist-medium-light": "left-facing-fist-medium-light.svg",
  "nail-polish-medium-dark": "nail-polish-medium-dark.svg",
  "thumbs-up-medium-light": "thumbs-up-medium-light.svg",
  "ear-with-hearing-aid-medium": "ear-with-hearing-aid-medium.svg",
  "right-facing-fist-3d": "right-facing-fist-3d.svg",
  "rightwards-pushing-hand-medium-dark":
    "rightwards-pushing-hand-medium-dark.svg",
  "raised-hand-dark": "raised-hand-dark.svg",
  "ear-with-hearing-aid-light": "ear-with-hearing-aid-light.svg",
  "folded-hands-dark": "folded-hands-dark.svg",
  "backhand-index-pointing-left-medium":
    "backhand-index-pointing-left-medium.svg",
  "rightwards-hand-dark": "rightwards-hand-dark.svg",
  brain: "brain.svg",
  "ear-medium-dark": "ear-medium-dark.svg",
  "call-me-hand-medium": "call-me-hand-medium.svg",
  "victory-hand-default": "victory-hand-default.svg",
  "palm-down-hand-medium-dark": "palm-down-hand-medium-dark.svg",
  "pinched-fingers-medium-dark": "pinched-fingers-medium-dark.svg",
  "folded-hands-3d": "folded-hands-3d.svg",
  "flexed-biceps-medium-dark": "flexed-biceps-medium-dark.svg",
  "thumbs-up-medium": "thumbs-up-medium.svg",
  "hand-with-index-finger-and-thumb-crossed-medium":
    "hand-with-index-finger-and-thumb-crossed-medium.svg",
  "backhand-index-pointing-down-medium-dark":
    "backhand-index-pointing-down-medium-dark.svg",
  "rightwards-hand-light": "rightwards-hand-light.svg",
  "rightwards-hand-medium-dark": "rightwards-hand-medium-dark.svg",
  "pinching-hand-3d": "pinching-hand-3d.svg",
  "middle-finger-medium-light": "middle-finger-medium-light.svg",
  "foot-default": "foot-default.svg",
  "foot-3d": "foot-3d.svg",
  "ok-hand-medium-light": "ok-hand-medium-light.svg",
  "rightwards-pushing-hand-dark": "rightwards-pushing-hand-dark.svg",
  "rightwards-pushing-hand-light": "rightwards-pushing-hand-light.svg",
  "flexed-biceps-dark": "flexed-biceps-dark.svg",
  "pinched-fingers-3d": "pinched-fingers-3d.svg",
  "selfie-dark": "selfie-dark.svg",
  "love-you-gesture-default": "love-you-gesture-default.svg",
  "leftwards-hand-medium-dark": "leftwards-hand-medium-dark.svg",
  "writing-hand-medium-dark": "writing-hand-medium-dark.svg",
  "clapping-hands-medium": "clapping-hands-medium.svg",
  "leg-default": "leg-default.svg",
  "palm-up-hand-medium-dark": "palm-up-hand-medium-dark.svg",
  "ear-with-hearing-aid-default": "ear-with-hearing-aid-default.svg",
  "palm-up-hand-light": "palm-up-hand-light.svg",
  "middle-finger-3d": "middle-finger-3d.svg",
  "pinched-fingers-light": "pinched-fingers-light.svg",
  "index-pointing-at-the-viewer-medium-light":
    "index-pointing-at-the-viewer-medium-light.svg",
  "nail-polish-default": "nail-polish-default.svg",
  "flexed-biceps-3d": "flexed-biceps-3d.svg",
  "ear-light": "ear-light.svg",
  "mechanical-arm": "mechanical-arm.svg",
  "oncoming-fist-medium-dark": "oncoming-fist-medium-dark.svg",
  "backhand-index-pointing-down-dark": "backhand-index-pointing-down-dark.svg",
  "ok-hand-default": "ok-hand-default.svg",
  "raised-back-of-hand-medium-dark": "raised-back-of-hand-medium-dark.svg",
  "nose-3d": "nose-3d.svg",
  "leftwards-hand-default": "leftwards-hand-default.svg",
  mouth: "mouth.svg",
  "selfie-medium-light": "selfie-medium-light.svg",
  "ear-dark": "ear-dark.svg",
  "raised-fist-medium": "raised-fist-medium.svg",
  "right-facing-fist-light": "right-facing-fist-light.svg",
  "nail-polish-dark": "nail-polish-dark.svg",
  "index-pointing-up-medium-light": "index-pointing-up-medium-light.svg",
  "open-hands-3d": "open-hands-3d.svg",
  "rightwards-hand-medium": "rightwards-hand-medium.svg",
  "vulcan-salute-light": "vulcan-salute-light.svg",
  "palm-up-hand-3d": "palm-up-hand-3d.svg",
  "right-facing-fist-medium": "right-facing-fist-medium.svg",
  "hand-with-fingers-splayed-light": "hand-with-fingers-splayed-light.svg",
  "anatomical-heart": "anatomical-heart.svg",
  "raised-fist-medium-light": "raised-fist-medium-light.svg",
  "foot-medium-dark": "foot-medium-dark.svg",
  "backhand-index-pointing-up-default":
    "backhand-index-pointing-up-default.svg",
  tongue: "tongue.svg",
  "leg-dark": "leg-dark.svg",
  "folded-hands-medium-light": "folded-hands-medium-light.svg",
  "hand-with-index-finger-and-thumb-crossed-light":
    "hand-with-index-finger-and-thumb-crossed-light.svg",
  "nose-light": "nose-light.svg",
  "leftwards-hand-3d": "leftwards-hand-3d.svg",
  "nail-polish-light": "nail-polish-light.svg",
  "left-facing-fist-3d": "left-facing-fist-3d.svg",
  "left-facing-fist-medium": "left-facing-fist-medium.svg",
  "index-pointing-up-3d": "index-pointing-up-3d.svg",
  "palms-up-together-medium-dark": "palms-up-together-medium-dark.svg",
  "hand-with-fingers-splayed-medium-dark":
    "hand-with-fingers-splayed-medium-dark.svg",
  "ear-with-hearing-aid-3d": "ear-with-hearing-aid-3d.svg",
  "waving-hand-medium": "waving-hand-medium.svg",
  "thumbs-down-medium": "thumbs-down-medium.svg",
  "leftwards-hand-dark": "leftwards-hand-dark.svg",
  "raising-hands-default": "raising-hands-default.svg",
  "raised-back-of-hand-dark": "raised-back-of-hand-dark.svg",
  "nose-medium-dark": "nose-medium-dark.svg",
  "backhand-index-pointing-up-3d": "backhand-index-pointing-up-3d.svg",
  "clapping-hands-medium-dark": "clapping-hands-medium-dark.svg",
  "nose-default": "nose-default.svg",
  "waving-hand-default": "waving-hand-default.svg",
  "victory-hand-light": "victory-hand-light.svg",
  "folded-hands-medium-dark": "folded-hands-medium-dark.svg",
  "right-facing-fist-medium-dark": "right-facing-fist-medium-dark.svg",
  "victory-hand-medium-dark": "victory-hand-medium-dark.svg",
  "palm-up-hand-medium-light": "palm-up-hand-medium-light.svg",
  "palm-up-hand-dark": "palm-up-hand-dark.svg",
  "pinching-hand-default": "pinching-hand-default.svg",
  "hand-with-index-finger-and-thumb-crossed-medium-dark":
    "hand-with-index-finger-and-thumb-crossed-medium-dark.svg",
  "vulcan-salute-medium-dark": "vulcan-salute-medium-dark.svg",
  "pinching-hand-medium": "pinching-hand-medium.svg",
  "heart-hands-dark": "heart-hands-dark.svg",
  "sign-of-the-horns-medium-light": "sign-of-the-horns-medium-light.svg",
  "writing-hand-3d": "writing-hand-3d.svg",
  "nose-medium": "nose-medium.svg",
  "ear-with-hearing-aid-dark": "ear-with-hearing-aid-dark.svg",
  "ok-hand-medium-dark": "ok-hand-medium-dark.svg",
  "ear-with-hearing-aid-medium-dark": "ear-with-hearing-aid-medium-dark.svg",
  "backhand-index-pointing-up-medium-dark":
    "backhand-index-pointing-up-medium-dark.svg",
  "pinching-hand-medium-light": "pinching-hand-medium-light.svg",
  "hand-with-fingers-splayed-dark": "hand-with-fingers-splayed-dark.svg",
  "rightwards-hand-3d": "rightwards-hand-3d.svg",
  "nail-polish-3d": "nail-polish-3d.svg",
  "flexed-biceps-medium-light": "flexed-biceps-medium-light.svg",
  "pinched-fingers-medium-light": "pinched-fingers-medium-light.svg",
  "backhand-index-pointing-down-light":
    "backhand-index-pointing-down-light.svg",
  "clapping-hands-3d": "clapping-hands-3d.svg",
  "hand-with-index-finger-and-thumb-crossed-3d":
    "hand-with-index-finger-and-thumb-crossed-3d.svg",
  "raised-fist-medium-dark": "raised-fist-medium-dark.svg",
  "pinching-hand-dark": "pinching-hand-dark.svg",
  "pinching-hand-medium-dark": "pinching-hand-medium-dark.svg",
  "raised-fist-default": "raised-fist-default.svg",
  "writing-hand-light": "writing-hand-light.svg",
  "call-me-hand-dark": "call-me-hand-dark.svg",
  "waving-hand-medium-light": "waving-hand-medium-light.svg",
  "folded-hands-medium": "folded-hands-medium.svg",
  "call-me-hand-medium-dark": "call-me-hand-medium-dark.svg",
  "love-you-gesture-medium": "love-you-gesture-medium.svg",
  "hand-with-fingers-splayed-medium-light":
    "hand-with-fingers-splayed-medium-light.svg",
  "rightwards-pushing-hand-medium-light":
    "rightwards-pushing-hand-medium-light.svg",
  "index-pointing-at-the-viewer-medium-dark":
    "index-pointing-at-the-viewer-medium-dark.svg",
  "raising-hands-dark": "raising-hands-dark.svg",
  "waving-hand-3d": "waving-hand-3d.svg",
  "flexed-biceps-default": "flexed-biceps-default.svg",
  "foot-medium-light": "foot-medium-light.svg",
  "oncoming-fist-light": "oncoming-fist-light.svg",
  "index-pointing-at-the-viewer-dark": "index-pointing-at-the-viewer-dark.svg",
  "victory-hand-dark": "victory-hand-dark.svg",
  "love-you-gesture-dark": "love-you-gesture-dark.svg",
  "ok-hand-medium": "ok-hand-medium.svg",
  "backhand-index-pointing-down-medium":
    "backhand-index-pointing-down-medium.svg",
  "call-me-hand-default": "call-me-hand-default.svg",
  "pinched-fingers-default": "pinched-fingers-default.svg",
  "backhand-index-pointing-right-dark":
    "backhand-index-pointing-right-dark.svg",
  "clapping-hands-light": "clapping-hands-light.svg",
  "oncoming-fist-dark": "oncoming-fist-dark.svg",
  "raised-back-of-hand-medium-light": "raised-back-of-hand-medium-light.svg",
  "ok-hand-dark": "ok-hand-dark.svg",
  "palms-up-together-dark": "palms-up-together-dark.svg",
  "open-hands-light": "open-hands-light.svg",
  "thumbs-up-dark": "thumbs-up-dark.svg",
  "backhand-index-pointing-down-3d": "backhand-index-pointing-down-3d.svg",
  "raised-hand-light": "raised-hand-light.svg",
  eyes: "eyes.svg",
  "raising-hands-medium-dark": "raising-hands-medium-dark.svg",
  "backhand-index-pointing-right-medium":
    "backhand-index-pointing-right-medium.svg",
  "raising-hands-light": "raising-hands-light.svg",
  "folded-hands-default": "folded-hands-default.svg",
  "index-pointing-up-medium-dark": "index-pointing-up-medium-dark.svg",
  "nail-polish-medium": "nail-polish-medium.svg",
  "palms-up-together-default": "palms-up-together-default.svg",
  "ear-default": "ear-default.svg",
  "palm-down-hand-default": "palm-down-hand-default.svg",
  bone: "bone.svg",
  "backhand-index-pointing-left-3d": "backhand-index-pointing-left-3d.svg",
  "raised-hand-default": "raised-hand-default.svg",
  "middle-finger-dark": "middle-finger-dark.svg",
  "open-hands-medium": "open-hands-medium.svg",
  "raised-hand-medium": "raised-hand-medium.svg",
  "leftwards-pushing-hand-dark": "leftwards-pushing-hand-dark.svg",
  "thumbs-down-dark": "thumbs-down-dark.svg",
  "raised-fist-light": "raised-fist-light.svg",
  "index-pointing-at-the-viewer-3d": "index-pointing-at-the-viewer-3d.svg",
  "thumbs-down-medium-light": "thumbs-down-medium-light.svg",
  "hand-with-fingers-splayed-default": "hand-with-fingers-splayed-default.svg",
  "ok-hand-3d": "ok-hand-3d.svg",
  "index-pointing-up-dark": "index-pointing-up-dark.svg",
  "palm-down-hand-medium-light": "palm-down-hand-medium-light.svg",
  "index-pointing-at-the-viewer-medium":
    "index-pointing-at-the-viewer-medium.svg",
  "raising-hands-medium-light": "raising-hands-medium-light.svg",
  "vulcan-salute-medium-light": "vulcan-salute-medium-light.svg",
  "clapping-hands-medium-light": "clapping-hands-medium-light.svg",
  "left-facing-fist-dark": "left-facing-fist-dark.svg",
  "raised-back-of-hand-medium": "raised-back-of-hand-medium.svg",
  "open-hands-default": "open-hands-default.svg",
  "backhand-index-pointing-left-light":
    "backhand-index-pointing-left-light.svg",
  "open-hands-dark": "open-hands-dark.svg",
  "writing-hand-dark": "writing-hand-dark.svg",
  "thumbs-up-medium-dark": "thumbs-up-medium-dark.svg",
  "leftwards-pushing-hand-light": "leftwards-pushing-hand-light.svg",
  "left-facing-fist-light": "left-facing-fist-light.svg",
  "palm-down-hand-dark": "palm-down-hand-dark.svg",
  "vulcan-salute-medium": "vulcan-salute-medium.svg",
  "clapping-hands-default": "clapping-hands-default.svg",
  "backhand-index-pointing-down-default":
    "backhand-index-pointing-down-default.svg",
  "call-me-hand-medium-light": "call-me-hand-medium-light.svg",
  "raised-back-of-hand-default": "raised-back-of-hand-default.svg",
  "raised-fist-3d": "raised-fist-3d.svg",
  "ear-medium-light": "ear-medium-light.svg",
  lungs: "lungs.svg",
  eye: "eye.svg",
  "right-facing-fist-default": "right-facing-fist-default.svg",
  "pinched-fingers-dark": "pinched-fingers-dark.svg",
  "backhand-index-pointing-up-light": "backhand-index-pointing-up-light.svg",
  "rightwards-pushing-hand-3d": "rightwards-pushing-hand-3d.svg",
  "heart-hands-medium": "heart-hands-medium.svg",
  "raising-hands-medium": "raising-hands-medium.svg",
  "palms-up-together-light": "palms-up-together-light.svg",
  "crossed-fingers-light": "crossed-fingers-light.svg",
  "hand-with-fingers-splayed-medium": "hand-with-fingers-splayed-medium.svg",
  "leftwards-hand-light": "leftwards-hand-light.svg",
  "pinching-hand-light": "pinching-hand-light.svg",
  "raising-hands-3d": "raising-hands-3d.svg",
  "heart-hands-default": "heart-hands-default.svg",
  "thumbs-up-3d": "thumbs-up-3d.svg",
  "heart-hands-light": "heart-hands-light.svg",
  "leftwards-pushing-hand-medium-light":
    "leftwards-pushing-hand-medium-light.svg",
  "middle-finger-medium-dark": "middle-finger-medium-dark.svg",
  "leg-light": "leg-light.svg",
  "raised-back-of-hand-light": "raised-back-of-hand-light.svg",
  "sign-of-the-horns-dark": "sign-of-the-horns-dark.svg",
  "leftwards-hand-medium": "leftwards-hand-medium.svg",
  "hand-with-index-finger-and-thumb-crossed-medium-light":
    "hand-with-index-finger-and-thumb-crossed-medium-light.svg",
  handshake: "handshake.svg",
  "backhand-index-pointing-down-medium-light":
    "backhand-index-pointing-down-medium-light.svg",
  "selfie-light": "selfie-light.svg",
  "backhand-index-pointing-up-medium": "backhand-index-pointing-up-medium.svg",
  "raised-back-of-hand-3d": "raised-back-of-hand-3d.svg",
  "writing-hand-medium": "writing-hand-medium.svg",
  "index-pointing-at-the-viewer-light":
    "index-pointing-at-the-viewer-light.svg",
  "palms-up-together-medium": "palms-up-together-medium.svg",
  "selfie-medium": "selfie-medium.svg",
  "victory-hand-3d": "victory-hand-3d.svg",
  "backhand-index-pointing-left-dark": "backhand-index-pointing-left-dark.svg",
  "backhand-index-pointing-right-light":
    "backhand-index-pointing-right-light.svg",
  tooth: "tooth.svg",
  "sign-of-the-horns-medium": "sign-of-the-horns-medium.svg",
  "pinched-fingers-medium": "pinched-fingers-medium.svg",
  "call-me-hand-3d": "call-me-hand-3d.svg",
  "mechanical-leg": "mechanical-leg.svg",
  "heart-hands-medium-light": "heart-hands-medium-light.svg",
  "palm-down-hand-medium": "palm-down-hand-medium.svg",
  "selfie-3d": "selfie-3d.svg",
  "nail-polish-medium-light": "nail-polish-medium-light.svg",
  "victory-hand-medium-light": "victory-hand-medium-light.svg",
  "leg-medium": "leg-medium.svg",
  "nose-dark": "nose-dark.svg",
  "thumbs-down-3d": "thumbs-down-3d.svg",
  "backhand-index-pointing-up-dark": "backhand-index-pointing-up-dark.svg",
  "leg-3d": "leg-3d.svg",
  "folded-hands-light": "folded-hands-light.svg",
  "open-hands-medium-light": "open-hands-medium-light.svg",
  "palm-down-hand-3d": "palm-down-hand-3d.svg",
  "thumbs-down-medium-dark": "thumbs-down-medium-dark.svg",
  "love-you-gesture-medium-dark": "love-you-gesture-medium-dark.svg",
  "backhand-index-pointing-up-medium-light":
    "backhand-index-pointing-up-medium-light.svg",
  "ok-hand-light": "ok-hand-light.svg",
  "crossed-fingers-dark": "crossed-fingers-dark.svg",
  "sign-of-the-horns-default": "sign-of-the-horns-default.svg",
  "crossed-fingers-medium-dark": "crossed-fingers-medium-dark.svg",
  "call-me-hand-light": "call-me-hand-light.svg",
  "crossed-fingers-3d": "crossed-fingers-3d.svg",
  "vulcan-salute-default": "vulcan-salute-default.svg",
  "right-facing-fist-medium-light": "right-facing-fist-medium-light.svg",
  "raised-fist-dark": "raised-fist-dark.svg",
  "thumbs-up-default": "thumbs-up-default.svg",
  "oncoming-fist-medium-light": "oncoming-fist-medium-light.svg",
  "oncoming-fist-medium": "oncoming-fist-medium.svg",
  "sign-of-the-horns-light": "sign-of-the-horns-light.svg",
  "hand-with-index-finger-and-thumb-crossed-default":
    "hand-with-index-finger-and-thumb-crossed-default.svg",
  "left-facing-fist-medium-dark": "left-facing-fist-medium-dark.svg",
  "leftwards-pushing-hand-default": "leftwards-pushing-hand-default.svg",
  "leg-medium-dark": "leg-medium-dark.svg",
  "index-pointing-up-light": "index-pointing-up-light.svg",
  "sign-of-the-horns-3d": "sign-of-the-horns-3d.svg",
  "leftwards-hand-medium-light": "leftwards-hand-medium-light.svg",
  "raised-hand-3d": "raised-hand-3d.svg",
  "love-you-gesture-3d": "love-you-gesture-3d.svg",
  "oncoming-fist-default": "oncoming-fist-default.svg",
  "backhand-index-pointing-left-medium-dark":
    "backhand-index-pointing-left-medium-dark.svg",
  "backhand-index-pointing-left-medium-light":
    "backhand-index-pointing-left-medium-light.svg",
  "leftwards-pushing-hand-medium": "leftwards-pushing-hand-medium.svg",
  "index-pointing-up-default": "index-pointing-up-default.svg",
  "love-you-gesture-medium-light": "love-you-gesture-medium-light.svg",
  "nose-medium-light": "nose-medium-light.svg",
  "index-pointing-at-the-viewer-default":
    "index-pointing-at-the-viewer-default.svg",
  "flexed-biceps-medium": "flexed-biceps-medium.svg",
  "rightwards-hand-default": "rightwards-hand-default.svg",
  "glass-icon-bag": "glass-icon-bag.svg",
  "glass-icon-tick": "glass-icon-tick.svg",
  "glass-icon-paper": "glass-icon-paper.svg",
  "glass-icon-wallet": "glass-icon-wallet.svg",
  "glass-icon-star": "glass-icon-star.svg",
  "glass-icon-chart": "glass-icon-chart.svg",
  "glass-icon-activity": "glass-icon-activity.svg",
  "glass-icon-home": "glass-icon-home.svg",
  "glass-icon-notification": "glass-icon-notification.svg",
};

export type EmojiKey = keyof typeof EMOJI_MAP;
